import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Pensaba que mi problema era vender más. Después de aplicar las primeras fases descubrí que estaba perdiendo dinero por errores que ni siquiera veía. Hoy sé exactamente cuánto gano cada mes.',
  name: 'Martín G.',
  role: 'Dueño de Comercio'
}, {
  quote: 'Mi negocio facturaba bien, pero siempre estaba preocupado por la plata. Este método me ayudó a ordenar todo y a tener mucha más tranquilidad.',
  name: 'Carla M.',
  role: 'Emprendedora'
}, {
  quote: 'Lo mejor es que está explicado de forma simple. En pocas semanas pude organizar mis números y dejar de tomar decisiones a ciegas.',
  name: 'Sebastián R.',
  role: 'Profesional Independiente'
}];
export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const next = () => setActiveIndex(i => (i + 1) % testimonials.length);
  const prev = () => setActiveIndex(i => (i - 1 + testimonials.length) % testimonials.length);
  return <section className="py-14 md:py-20 bg-surface" data-id="element-272">
      <div className="container mx-auto px-5 md:px-6" data-id="element-273">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-274">
          <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3 md:mb-6 text-balance" data-id="element-275">
            LO QUE DICEN QUIENES YA COMENZARON A{' '}
            <span className="text-primary italic" data-id="element-276">IMPLEMENTAR EL MÉTODO</span>
          </h2>
        </motion.div>

        {/* Desktop: 3-column grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto" data-id="element-277">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.12
        }} className="bg-background rounded-3xl p-7 lg:p-8 border border-surface-light flex flex-col relative" data-id="element-278">
              <div className="absolute top-6 right-6 text-5xl font-serif text-surface-light leading-none select-none" data-id="element-279">
                "
              </div>
              <div className="flex gap-1 mb-5 relative z-10" data-id="element-280">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-gold text-gold" data-id="element-281" />)}
              </div>
              <p className="text-base lg:text-lg text-text-muted leading-relaxed mb-6 flex-grow relative z-10" data-id="element-282">
                "{t.quote}"
              </p>
              <div className="pt-5 border-t border-surface-light" data-id="element-283">
                <p className="font-bold text-white" data-id="element-284">{t.name}</p>
                <p className="text-primary-light text-xs" data-id="element-285">{t.role}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Mobile: swipeable carousel */}
        <div className="md:hidden max-w-md mx-auto" data-id="element-286">
          <div className="relative bg-background rounded-2xl p-5 border border-surface-light min-h-[260px] overflow-hidden" data-id="element-287">
            <AnimatePresence mode="wait" data-id="element-288">
              <motion.div key={activeIndex} initial={{
              opacity: 0,
              x: 30
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -30
            }} transition={{
              duration: 0.3
            }} className="flex flex-col" data-id="element-289">
                <div className="absolute top-4 right-4 text-5xl font-serif text-surface-light leading-none select-none" data-id="element-290">
                  "
                </div>
                <div className="flex gap-1 mb-4 relative z-10" data-id="element-291">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-gold text-gold" data-id="element-292" />)}
                </div>
                <p className="text-sm text-text-muted leading-relaxed mb-5 relative z-10" data-id="element-293">
                  "{testimonials[activeIndex].quote}"
                </p>
                <div className="pt-4 border-t border-surface-light" data-id="element-294">
                  <p className="font-bold text-white text-sm" data-id="element-295">
                    {testimonials[activeIndex].name}
                  </p>
                  <p className="text-primary-light text-xs" data-id="element-296">
                    {testimonials[activeIndex].role}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-between mt-4" data-id="element-297">
            <button onClick={prev} aria-label="Anterior" className="w-9 h-9 rounded-full bg-background border border-surface-light flex items-center justify-center text-white active:scale-95 transition-transform" data-id="element-298">
              <ChevronLeftIcon className="w-4 h-4" data-id="element-299" />
            </button>

            <div className="flex gap-2" data-id="element-300">
              {testimonials.map((_, i) => <button key={i} onClick={() => setActiveIndex(i)} aria-label={`Testimonio ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === activeIndex ? 'w-6 bg-primary' : 'w-1.5 bg-surface-light'}`} data-id="element-301" />)}
            </div>

            <button onClick={next} aria-label="Siguiente" className="w-9 h-9 rounded-full bg-background border border-surface-light flex items-center justify-center text-white active:scale-95 transition-transform" data-id="element-302">
              <ChevronRightIcon className="w-4 h-4" data-id="element-303" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}